export default __webpack_public_path__ + "static/media/google.9c3e727e.svg";